import { AudioClip, Asset, Font, JsonAsset, Prefab, sp, SpriteAtlas, SpriteFrame, Scene, VideoClip } from 'cc';

export enum AssetName {
    JSON = 'json',
    SPRITE_FRAME = 'spriteFrame',
    SPRITE_ATLAS = 'spriteAtlas',
    SKELETON_DATA = 'skeletonData',
    FONT = 'font',
    PREFAB = 'prefab',
    AUDIO_CLIP = 'audioClip',
    VIDEO_CLIP = 'videoClip',
}

export const assetNameToAssetTypeMap: Record<AssetName, typeof Asset> = {
    [AssetName.JSON]: JsonAsset,
    [AssetName.SPRITE_FRAME]: SpriteFrame,
    [AssetName.SPRITE_ATLAS]: SpriteAtlas,
    [AssetName.SKELETON_DATA]: sp.SkeletonData,
    [AssetName.FONT]: Font,
    [AssetName.PREFAB]: Prefab,
    [AssetName.AUDIO_CLIP]: AudioClip,
    [AssetName.VIDEO_CLIP]: VideoClip,
};
export const assetTypeToAssetNameMap: Map<typeof Asset, AssetName> = new Map<typeof Asset, AssetName>([
    [JsonAsset, AssetName.JSON],
    [SpriteFrame, AssetName.SPRITE_FRAME],
    [SpriteAtlas, AssetName.SPRITE_ATLAS],
    [sp.SkeletonData, AssetName.SKELETON_DATA],
    [Font, AssetName.FONT],
    [Prefab, AssetName.PREFAB],
    [AudioClip, AssetName.AUDIO_CLIP],
    [VideoClip, AssetName.VIDEO_CLIP],
]);

export enum LoadingType {
    PRELOAD,
    LAZY,
    ON_DEMAND,
}

export type PathLoadingConfigType =
    | string
    | {
          path: string;
          type?: LoadingType;
          isDir?: boolean;
          assetPrefix?: boolean | string;
          /**
           * Used to define custom logic for deciding whether an asset should be loaded.
           * For example, if a texture is released in the loading scene, you may want to skip
           * loading it again after entering the game scene.
           */
          shouldLoad?: boolean;
      };

type AssetLoadingConfigType = {
    bundleName: string;
    /**
     * use to be identified when there are multiple asset loading configs with the same bundleName and prefix
     */
    uniqueID?: string;
    /**
     * prefix to be used when target directory already inside the bundle
     */
    prefix?: string;
    path: Partial<Record<AssetName, Record<string, PathLoadingConfigType>>>;
    /**
     * tags to be used for deciding which scene should start lazy loading
     * @description
     * with tags 'Game' and 'Lobby' being set,
     * scene with name 'Game'、'TestGame' and 'Lobby' will start lazy loading when scene is loaded
     */
    triggerLazyLoadingSceneTags?: string[];

    /**
     * defer lazy loading until the returned promise is resolved
     * @param scene the scene that triggers lazy loading, you can get necessary components from the scene to decide when to resolve the promise
     * @description because triggerLazyLoading is triggered at EVENT_AFTER_SCENE_LAUNCH, make sure setup the defer promise at onLoad lifecycle or before
     */
    deferredLazyLoading?: (scene: Scene) => Promise<void>;

    /**
     * max concurrency for lazy loading
     */
    lazyLoadingMaxConcurrency?: number;
    /**
     * max requests per frame for lazy loading
     */
    lazyLoadingMaxRequestsPerFrame?: number;
};

export default AssetLoadingConfigType;
